import markdownContent from '!!raw-loader!static/imprint.md';
import { Markdown } from 'Common';

const AppImprintPage = () => {
  return (
    <Markdown className="app" scrollOffset={-10}>
      {markdownContent}
    </Markdown>
  );
};

export default AppImprintPage;
